import { render, staticRenderFns } from "./MainManagerTable.vue?vue&type=template&id=51b9f520&"
import script from "./MainManagerTable.vue?vue&type=script&lang=js&"
export * from "./MainManagerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports